<template lang="pug">
    article#cursos
        Banner(v-bind="tipos_cursos[tipoAtual].banner")
        Filtros(v-model="busca", :tag.sync="tag", :areas="tags", :sort.sync="sort", v-if="tags.length")
        Listagem(:cursos="cursosExibicao", v-if="cursosExibicao.length")
        .sem-resultados(v-else-if="!cursosExibicao.length && (busca || tag) && !loading")
            h3 {{ mensagemSemResultados }}
        Loader(tamanho="large", v-else).verde
        Unidades
</template>

<script>
import qs from 'qs'

import Banner from '@sections/Cursos/Banner/Banner'
import Filtros from '@sections/Cursos/Filtros/Filtros'
import Listagem from '@sections/Cursos/Listagem/Listagem'

import Loader from '@components/Loader/Loader'
import Unidades from '@sections/Home/Unidades/Unidades'
import pagina from '@/mixins/pagina'

const tipos_cursos = {
    graduacao: {
        banner: {
            background: require('@images/cursos/bg-cursos-graduacao.png'),
            cores: ['#232540', '#2f354b'],
            politicas: false,
            titulo: 'Graduação',
            vantagens: [
                '100% digital, mas presencial quando você mais precisa',
                'Livros físicos e digitais',
                'Mais de 600 polos de atendimento em todo Brasil',
                'Interação com professores e alunos durante todo o curso',
                'App exclusivo para o aluno UniFAEL',
            ],
        },
    },
    'pos-graduacao': {
        banner: {
            background: require('@images/cursos/bg-cursos-pos.png'),
            cores: ['#580d52', '#c45840'],
            politicas: false,
            titulo: 'Pós-Graduação',
            vantagens: [
                'A Pós mais barata do Brasil',
                'Conclusão a partir de 6 meses',
                'Material didático exclusivo',
                '100% Online. Você estuda no seu tempo, onde e quando quiser',
                'App exclusivo para o aluno UniFAEL',
            ],
        },
    },
    saude: {
        banner: {
            background: require('@images/cursos/bg-cursos-saude.jpg'),
            cores: ['#99dc00', '#527c00'],
            politicas: true,
            titulo: 'Área de Saúde',
            vantagens: [
                '100% digital, mas presencial quando você mais precisa',
                'Biblioteca Digital',
                'Recursos tecnológicos para o acompanhamento de todo conteúdo',
                'Professores Especializados',
            ],
        },
    },
    tecnico: {
        banner: {
            background: require('@images/cursos/bg-cursos-tecnico.png'),
            cores: ['#f48f06', '#ff6349'],
            politicas: false,
            titulo: 'Curso Técnico',
            vantagens: [
                'Você começa seu curso quando quiser',
                '100% digital, mas presencial quando você mais precisa',
                'Programa Jovens Protagonistas com Davi Braga',
                'Finalize o estágio e saia pronto para o mercado de trabalho',
                'A maior em EAD do Brasil',
            ],
        },
    },
}

export default {
    name: "view-cursos",
    components: {
        Banner,
        Filtros,
        Listagem,
        Loader,
        Unidades,
    },
    mixins: [
        pagina
    ],
    data() {
        return {
            tipos_cursos,
            cursos: [],
            tags: [],
            busca: '',
            tag: null,
            sort: null,
            loading: false,
        }
    },
    computed: {
        tipoAtual() {
            return this.$route.params.tipo
        },
        cursosExibicao() {
            if (this.busca)
                return this.cursos.filter(curso => curso.nome_curso.toUpperCase().includes(this.busca.toUpperCase()) || curso.slug.toUpperCase().includes(this.busca.toUpperCase()))
            return this.cursos
        },
        mensagemSemResultados() {
            if (this.tag) {
                if (this.busca)
                    return `Não foram encontrados resultados para ${ this.busca } em ${ this.tag }.`
                return `Não foram encontrados resultados em ${ this.tag }.`
            }
            if (this.busca)
                return `Não foram encontrados resultados para ${ this.busca }.`
            return `Não foram encontrados resultados.`
        },
    },
    watch: {
        sort: function () {
            this.loadCursos(this.$route.params.tipo)
        },
        tag: function () {
            this.loadCursos(this.$route.params.tipo)
        }
    },
    created() {
		if(this.$route.query && this.$route.query.tag && this.$route.query.tag !== "")
			this.tag = this.$route.query.tag;
        this.loadCursos(this.$route.params.tipo)
        this.loadAreas(this.$route.params.tipo)
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.tipo == 'graduacao' || to.params.tipo == 'saude') {
            window.open('//vestibular.fael.edu.br', '_blank')
            return next(false)
        }
        if (to.name == 'cursos' && to.params.tipo != from.params.tipo) {
            this.busca = ''
            this.sort = null
			if(to.query.tag && to.query.tag !== "")
				this.tag = to.query.tag
			else
				this.tag = null
            this.loadCursos(to.params.tipo)
            this.loadAreas(to.params.tipo)
        }
        next()
    },
    methods: {
        loadCursos(tipo) {
            let params = Object.assign({}, {sort: this.sort, tag: this.tag})
            this.cursos = []
            this.loading = true
            this.$axios
            .get(`cursos/${tipo}?${qs.stringify(params, {skipNulls: true})}`)
            .then(response => this.cursos = response.data)
            .then(() => this.loading = false)
        },
        loadAreas(tipo) {
            this.tags = []
            this.$axios
            .get(`cursos/tags/${ tipo }`)
            .then(response => this.tags = response.data)
        }
    },
}
</script>

<style lang="stylus" scoped src="./Cursos.styl"></style>
